var inputNumberAndLetter = (rule, value, callback) => {
  var zg = /^[0-9]*[1-9][0-9]*$/;
  if (!zg.test(value)) {
    callback(new Error('请输入正整数'));
  }else if(Number(value)>999999||Number(value)<1){
    callback(new Error('请输入1-999999数字'));
  } else {
    callback();
  }
};
export default {
  submitText: '保存',
  emptyBtn: false,
  labelWidth: 150,
  column: [
    {
      label: '主键/房产编号',
      prop: 'id',
      display: false,
      /*rules: [
        {
          required: true,
          message: '请输入主键/房产编号',
          trigger: 'change',
        },
      ],*/
    },
    // {
    //   label: '上级节点id',
    //   prop: 'parentId',
    //   display: false,
    //   readonly: true,
    //   span: 12,
    // },
    // {
    //   label: '上级节点',
    //   prop: 'parentObjectName',
    //   disabled: true,
    //   span: 12,
    // },
    {
      label: '上级节点',
      prop: 'parentId',
      formslot: true,
     
      span: 12,
    },
    {
      label: '上级节点',
      prop: 'parentObjectName',
      display: false,
      span: 12,
    },
    {
      label: '上级属性',
      prop: 'parentObjectTypeName',
      disabled: true,
      span: 12,
    },
    {
      label: '本级属性',
      prop: 'objectType',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [{ required: true, message: '请输入本级属性', trigger: 'change' }],
      span: 12,
    },
    {
      label: '顺序号',
      prop: 'indexNum',
      type: 'number',
      rules: [
        { required: true, message: '请输入顺序号' },
        {
          validator: inputNumberAndLetter,
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '属性编码',
      prop: 'objectCode',
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入属性编码',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '房屋性质',
      prop: 'useType',
      type: 'select',
      dataType: 'number',
      dicUrl: 'api/base/property/getUseTypes?code=use_type&remark=0',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: false,
          message: '请选择房屋性质',
          trigger: 'blur',
        },
      ],
      span: 8,
    },
    {
      label: '属性名称',
      prop: 'objectName',
      rules: [
        {
          required: true,
          message: '请输入属性名称',
          trigger: 'blur',
        },
      ],
      span: 12,
    },
    {
      label: '建筑面积',
      prop: 'floorage',
      placeholder: '请输入 建筑面积，单位m2',
      rules: [
        {
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      span: 12,
    },
    {
      label: '使用面积',
      prop: 'usableArea',
      placeholder: '请输入 使用面积，单位m2',
      rules: [
        {
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      span: 12,
    },
    {
      label: '门数量',
      prop: 'doorsNum',
      placeholder: '请输入 门数量',
      rules: [{ pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数' }],
      span: 12,
    },
    {
      label: '小区分组',
      prop: 'communityGroup',
      type: 'select',
      dataType: 'string',
      dicUrl: 'api/blade-system/dict-biz/dictionary?code=community_group',
      props: { label: 'dictValue', value: 'dictKey' },
      // rules: [{ required: true, message: '请输入小区分组', trigger: 'change' }],
      span: 12,
    },
    {
      label: '用途',
      prop: 'useDesc',
      span: 12,
      maxlength: 50,
    },
    {
      label: '环境描述',
      prop: 'envDesc',
      span: 24,
      maxlength: 300,
    },
    {
      label: '总面积',
      prop: 'totalArea',
      display: false,
      rules: [
        {
          required: true,
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      placeholder: '请输入 总面积，单位m2',
      span: 8,
    },
    {
      label: '已用面积',
      prop: 'usedArea',
      display: false,
      rules: [
        {
          required: true,
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      placeholder: '请输入 已用面积，单位m2',
      span: 8,
    },
    {
      label: '可用面积',
      prop: 'availableArea',
      display: false,
      rules: [
        {
          required: true,
          pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          message: '请输入整数10位，小数2位',
        },
      ],
      placeholder: '请输入 可用面积，单位m2',
      span: 8,
    },
    {
      label: '是否支持业主端使用',
      prop: 'supportClientUse',
      type: 'switch',
      dicData: [
        {
          label: '否',
          value: 'NO'
        },
        {
          label: '是',
          value: 'YES'
        },
      ],
      span: 8,
    }
  ],
};
